angular
    .module('dnecom.component.product')
    .directive('productHref', ["ProductFrontendUtils", function (ProductFrontendUtils) {
        return {
            scope: {
                product: '=productHref',
                mobile: '=mobile',
                anchor: '=anchor'
            },

            link: function(scope, element) {
                element.attr('href', ProductFrontendUtils.url(scope.product, scope.mobile, scope.anchor));
            }
        }
    }]);